import { createSlice } from '@reduxjs/toolkit';
import * as actionType from './Types';

const initialState = {
  layout: 'vertical', // vertical, horizontal
  subLayout: '', // horizontal-2
  collapseMenu: false, // mini-menu
  layoutType: 'menu-light', // menu-dark, menu-light, dark
  headerBackColor: 'header-blue', // header-blue, header-red, header-purple, header-info, header-green header-dark
  rtlLayout: false,
  navFixedLayout: true,
  headerFixedLayout: true,
  boxLayout: false,
  isOpen: [], // for active default menu
  isTrigger: [], // for active default menu, set blank for horizontal
  BASENAME: '',
  BASE_URL: '/',
  BASE_TITLE: ' | Emma Information Portal'
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    update: (state, { payload }) => {
      let trigger = [];
      let open = [];
      try {
        switch (payload.type) {
          case actionType.BOX_LAYOUT:
            return {
              ...state,
              boxLayout: !state.boxLayout
            };
          case actionType.CHANGE_LAYOUT:
            return {
              ...state,
              layout: payload.layout
            };
          case actionType.CHANGE_SUB_LAYOUT:
            return {
              ...state,
              subLayout: payload.subLayout
            };
          case actionType.COLLAPSE_MENU:
            return {
              ...state,
              collapseMenu: !state.collapseMenu
            };
          case actionType.RESET_COLLAPSE_MENU:
            return {
              ...state,
              isOpen: []
            };
          case actionType.COLLAPSE_TOGGLE:
            if (payload.menu.type === 'sub') {
              open = state.isOpen;
              trigger = state.isTrigger;

              const triggerIndex = trigger.indexOf(payload.menu.id);
              if (triggerIndex > -1) {
                open = open.filter((item) => item !== payload.menu.id);
                trigger = trigger.filter((item) => item !== payload.menu.id);
              }

              if (triggerIndex === -1) {
                open = [...open, payload.menu.id];
                trigger = [...trigger, payload.menu.id];
              }
            } else {
              open = state.isOpen;
              const triggerIndex = state.isTrigger.indexOf(payload.menu.id);
              trigger = triggerIndex === -1 ? [payload.menu.id] : [];
              open = triggerIndex === -1 ? [payload.menu.id] : [];
            }

            return {
              ...state,
              isOpen: open,
              isTrigger: trigger
            };
          case actionType.HEADER_BACK_COLOR:
            return {
              ...state,
              headerBackColor: payload.headerBackColor
            };
          case actionType.HEADER_FIXED_LAYOUT:
            return {
              ...state,
              headerFixedLayout: !state.headerFixedLayout,
              headerBackColor:
                !state.headerFixedLayout && initialState.headerBackColor === ''
                  ? 'header-blue'
                  : state.headerBackColor
            };
          case actionType.LAYOUT_TYPE:
            return {
              ...state,
              layoutType: payload.layoutType,
              headerBackColor: initialState.headerBackColor
            };
          case actionType.NAV_COLLAPSE_LEAVE:
            if (payload.menu.type === 'sub') {
              open = state.isOpen;
              trigger = state.isTrigger;

              const triggerIndex = trigger.indexOf(payload.menu.id);
              if (triggerIndex > -1) {
                open = open.filter((item) => item !== payload.menu.id);
                trigger = trigger.filter((item) => item !== payload.menu.id);
              }
              return {
                ...state,
                isOpen: open,
                isTrigger: trigger
              };
            }
            return { ...state };
          case actionType.NAV_CONTENT_LEAVE:
            return {
              ...state,
              isOpen: open,
              isTrigger: trigger
            };
          case actionType.NAV_FIXED_LAYOUT:
            return {
              ...state,
              navFixedLayout: !state.navFixedLayout
            };
          case actionType.RTL_LAYOUT:
            return {
              ...state,
              rtlLayout: !state.rtlLayout
            };
          case actionType.RESET:
            return {
              ...state,
              layout: initialState.layout,
              subLayout: initialState.subLayout,
              collapseMenu: initialState.collapseMenu,
              layoutType: initialState.layoutType,
              headerBackColor: initialState.headerBackColor,
              rtlLayout: initialState.rtlLayout,
              navFixedLayout: initialState.navFixedLayout,
              headerFixedLayout: initialState.headerFixedLayout,
              boxLayout: initialState.boxLayout
            };
          default:
            return initialState;
        }
      } catch (e) {
        console.log(e);
      }
    },
    reset: () => {
      return initialState;
    }
  },
  extraReducers: (builder) => {
    builder.addCase('auth/logout', () => {
      return initialState;
    });
  }
});

export default configSlice.reducer;
export const configActions = configSlice.actions;
